// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"272":"56af1d01","693":"a6acfd9b","790":"38397bca"}[chunkId] + ".chunk.css";
};